import { Injectable, computed, inject, signal } from "@angular/core";
import { FeatureFlagService } from "@app/core/services/feature-flag.service";
import {
  DEFAULT_ENRICHMENT_MODE,
  ENRICHMENT_MODES,
  ENRICHMENT_MODE_STORAGE_KEY,
  EnrichmentMode,
  parseEnrichmentMode,
} from "./enrichment-mode.model";

function readStoredMode(): EnrichmentMode | null {
  try {
    return parseEnrichmentMode(
      globalThis.localStorage?.getItem(ENRICHMENT_MODE_STORAGE_KEY),
    );
  } catch {
    return null;
  }
}

@Injectable({ providedIn: "root" })
export class EnrichmentModeStore {
  private readonly flags = inject(FeatureFlagService);

  readonly stored = signal<EnrichmentMode | null>(readStoredMode());

  readonly effective = computed<EnrichmentMode>(() => {
    const stored = this.stored();
    return stored && this.available(stored) ? stored : DEFAULT_ENRICHMENT_MODE;
  });

  available(mode: EnrichmentMode): boolean {
    const flag = ENRICHMENT_MODES[mode].flag;
    return flag === null || this.flags.get(flag);
  }

  set(mode: EnrichmentMode): void {
    this.stored.set(mode);
    try {
      globalThis.localStorage?.setItem(ENRICHMENT_MODE_STORAGE_KEY, mode);
    } catch {
      /* remembered for this tab only */
    }
  }
}
